import { render, staticRenderFns } from "./Comisiones.vue?vue&type=template&id=6723d8c8&scoped=true"
import script from "./Comisiones.vue?vue&type=script&lang=js"
export * from "./Comisiones.vue?vue&type=script&lang=js"
import style0 from "./Comisiones.vue?vue&type=style&index=0&id=6723d8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6723d8c8",
  null
  
)

export default component.exports